export enum QuestionAnswerType {
  MultipleChoiceAnswers = 'M',
  MultiSelectAnswers = 'S',
  ArrangeInOrder = 'O',
  OpenAnswer = 'F'
}
